<template>
  <b-card align="center">
    <!-- ID, temporalidad y clave -->
    <div class="mb-1">
      <!-- ID y temporalidad -->
      <div>
        <!-- ID de periodo -->
        <h2 class="mb-0 text-primary">
          Periodo <b>{{ periodo.clave }}</b>
        </h2>
        <!-- Temporalidad -->
        <p class="mb-0 text-body font-medium-1 font-weight-bold">
          {{ periodo.temp_nombre }}
        </p>
      </div>
    </div>

    <!-- capacidad, privado -->
    <b-row class="text-center mx-0">
      <b-col
        cols="6"
        class="d-flex align-items-between flex-column py-1"
      >
        <div>
          <p class="mb-0 text-body font-medium-1 font-weight-bold">
            Capacidad <b>{{ periodo.capacidad !== null ? periodo.capacidad : 'Ilimitada' }}</b>
          </p>
        </div>
      </b-col>
      <b-col
        cols="6"
        class="d-flex align-items-between flex-column py-1"
      >
        <div>
          <p class="mb-0 text-body font-medium-1 font-weight-bold">
            <span v-if="periodo.privado === 1">Privado</span>
            <span v-else>Público</span>
          </p>
        </div>
      </b-col>
    </b-row>
    <!-- Documentos requeridos -->
    <b-row class="text-center mx-0">
      <b-col
        cols="12"
        class="d-flex align-items-between flex-column py-1"
      >
        <div>
          <p
            v-if="periodo.requiere_docs===1"
          > Requerirá Documentación
          </p>
          <p v-else>
            <b>No</b> Requerirá Documentación
          </p>
        </div>
      </b-col>
    </b-row>
    <!-- Fecha de inicio y fin -->
    <b-row class="text-center mx-0">
      <!-- Fecha de inicio -->
      <b-col
        cols="6"
        class="border-top border-right d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          Inicia
        </b-card-text>
        <h5 class="font-weight-bolder mb-50">
          {{ timestampToDate(periodo.fecha_ini, 'LL') }}
        </h5>
      </b-col>

      <!-- Fecha de fin -->
      <b-col
        cols="6"
        class="border-top d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          Termina
        </b-card-text>
        <h5 class="font-weight-bolder mb-0">
          {{ timestampToDate(periodo.fecha_fin, 'LL') }}
        </h5>
      </b-col>
    </b-row>

    <!-- Botón para editar -->
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      block
      class="mt-2"
      variant="primary"
      @click="$emit('will-edit')"
    >
      Editar
    </b-button>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { timestampToDate } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    periodo: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {
      timestampToDate,
    }
  },
}
</script>
